import _get from 'lodash/get';
import _kebabCase from 'lodash/kebabCase';

import { Google, GoogleTransformers } from 'reaxl-analytics-handlers';

import { getInventoryOwnerById } from '@/analytics/utilities';

const { inventoryTransformer: googleInventoryTransformer } = GoogleTransformers;
/**
 *
 * @summary Google impression for vehicle warranty info on vdp
 * warrantyType examples: limited, factory, peace of mind, and added protection
 *
 */
export function inventoryWarrantyDetailImpression(metadata, option) {
    const {
        data = {},
        dataLayer = {},
        state,
    } = metadata;

    const { warrantyType, inventoryId } = data;
    const pageName = _get(dataLayer, 'page.pageName', '');
    const inheritPageData = !['vdp'].includes(pageName);
    const inventory = getInventoryOwnerById(state, inventoryId);
    const vehicleData = googleInventoryTransformer(inventory, { target: 'vehicle', dataLayer }, inheritPageData);
    const eventData = {
        vehicle: { ...vehicleData },
    };

    const type = warrantyType.toLowerCase();

    let cmp = `cta::view-details::${_kebabCase(type)}`;

    if (['limited', 'factory'].includes(type)) {
        cmp = `cta::see-details::${type}-warranty`;
    }

    const element = `vdp_${data?.listingType.toLowerCase()}`;

    Google.sendImpressions(metadata, {
        eventElement: element,
        eventResult: cmp,
        eventData,
    }, option);

    return { cmp, element };
}
